var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3888 7.30262L12 13.1M12 13.1L1.61107 7.30262M12 13.1L12 24.7629M23 18.0826V8.11742C23 7.69677 23 7.48644 22.9383 7.29885C22.8837 7.1329 22.7945 6.98057 22.6766 6.85204C22.5433 6.70676 22.3602 6.60462 21.9941 6.40033L12.9497 1.35323C12.6031 1.1598 12.4298 1.06309 12.2462 1.02517C12.0838 0.99161 11.9162 0.99161 11.7538 1.02517C11.5702 1.06309 11.3969 1.1598 11.0503 1.35323L2.00585 6.40034C1.63977 6.60462 1.45673 6.70677 1.32344 6.85205C1.20553 6.98057 1.11629 7.1329 1.0617 7.29886C1 7.48644 1 7.69677 1 8.11742V18.0826C1 18.5032 1 18.7136 1.0617 18.9011C1.11629 19.0671 1.20553 19.2194 1.32344 19.348C1.45673 19.4932 1.63977 19.5954 2.00585 19.7997L11.0503 24.8468C11.3969 25.0402 11.5702 25.1369 11.7538 25.1748C11.9162 25.2084 12.0838 25.2084 12.2462 25.1748C12.4298 25.1369 12.6031 25.0402 12.9497 24.8468L21.9941 19.7997C22.3602 19.5954 22.5433 19.4932 22.6766 19.348C22.7945 19.2194 22.8837 19.0671 22.9383 18.9011C23 18.7136 23 18.5032 23 18.0826Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModel);
export default __webpack_public_path__ + "static/media/Model.8673b85100dd20464f6136a6dec49043.svg";
export { ForwardRef as ReactComponent };